<div class="text-center pt-5">
	<h2 class="text-danger">🚫 Access Denied</h2>
	<p class="lead">Your registration has been rejected</p>
</div>
